const KeenSlider = window.KeenSlider

const { useAutoplay } = window.BAO.Carousel.plugins

const { getElements } = window.BAO.Utils

class AnnouncementBar extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.setHeight = this.setHeight.bind(this)

    window.addEventListener('resize', this.setHeight)
    this.setHeight()

    if (this.els.slide.elements.length < 2) return

    this.numberOfDesktopSlides = getElements(
      `${this.els.slide.selector}:not(.hd-Announcement_Slide-mobile)`,
    ).length

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.handleClipboardTrigger = this.handleClipboardTrigger.bind(this)

    this.els?.['clipboard-button']?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleClipboardTrigger)
    })
  }

  setHeight () {
    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.els.body.element.offsetHeight}px`,
    )
  }

  handleClipboardTrigger (e) {
    e.preventDefault()

    const inputValue = e.target.dataset.code.trim()
    const textAfter = e.target.dataset.textAfter
    const originalText = e.target.innerText

    if (!inputValue) {
      alert('No code specified')
      return
    }
    navigator.clipboard
      .writeText(inputValue)
      .then(() => {
        if (e.target.innerText !== textAfter) {
          e.target.innerText = textAfter
          setTimeout(() => {
            e.target.innerText = originalText
          }, 3000)
        }
      })
      .catch(() => {
        alert('Something went wrong')
      })
  }

  setupCarousel () {
    const autoplayTimeout = this.dataset.autoplay

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        defaultAnimation: {
          duration: 1500,
        },
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            selector: `${this.els.slide.selector}:not(.hd-Announcement_Slide-mobile)`,
            disabled: this.numberOfDesktopSlides < 2,
          },
        },
      },
      autoplayTimeout && [useAutoplay(parseInt(autoplayTimeout))],
    )
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
